var setValue = function (value, key) {
    if (key === void 0) { key = 'user'; }
    var name = "rsteam17-".concat(key);
    var valueJSON = JSON.stringify(value);
    localStorage.setItem(name, valueJSON);
};
var getValue = function (key) {
    if (key === void 0) { key = 'user'; }
    var name = "rsteam17-".concat(key);
    var value = JSON.parse(localStorage.getItem(name));
    return value;
};
var resetValue = function (key) {
    if (key === void 0) { key = 'user'; }
    var name = "rsteam17-".concat(key);
    localStorage.removeItem(name);
};
export { setValue, getValue, resetValue };
